import { Component, inject, Input } from '@angular/core'
import { SystemConfigService } from '@account/Services/SystemConfigService'
import { BaseCurrencyComponent } from '@ui/Components/Currency/BaseCurrency.Component'

@Component({
	selector: 'client-currency',
	template:
		'<base-currency-component [currency]="currency" [value]="value" [locale]="locale" [precision]="precision"></base-currency-component>',
	imports: [BaseCurrencyComponent],
})
export class CurrencyComponent {
	@Input() public value: number

	public currency: string

	public locale: string

	public precision: number

	constructor() {
		const systemConfigService = inject(SystemConfigService)
		this.currency = systemConfigService.config.currency
		this.locale = systemConfigService.config.locale
		this.precision = systemConfigService.config.currencyDecimalPlaces
	}
}
